import { ComputedRef } from 'vue';
import { PreferenceItem } from 'features/settings/preferences/interfaces';
import { UserRoles } from 'features/residents/types/hubstr';
import { ACK_DOCUMENTS_ROUTE, ACK_DOCUMENTS_SETTING_CODE } from 'features/ack-documents/types';
import useStore from '~/store/useStore';

/** Нужен только getRoutes: в magner/vue-router тип Router не реэкспортируется */
interface RoutesSource {
  getRoutes: () => { props?: Record<string, unknown> }[],
}

const ACK_DOCUMENTS_ROLES: string[] = [UserRoles.Admin, UserRoles.Proforg];

/**
 * Раздел доступен, только если в клубе включена настройка ack_documents.enabled
 * и у пользователя есть роль ROLE_ADMIN или ROLE_PROFORG (остальным бэк отвечает 403).
 * Вызывается часто, поэтому без логов.
 */
export const isAckDocumentsAvailable = (): boolean => {
  const store = useStore();
  const preferences = (store.preferences as unknown as ComputedRef<PreferenceItem[]>).value ?? [];
  const userRoles = (store.userRoles as unknown as ComputedRef<string[]>).value ?? [];

  const isEnabled = preferences.find((item) => item.code === ACK_DOCUMENTS_SETTING_CODE)?.value === true;

  return isEnabled && userRoles.some((role) => ACK_DOCUMENTS_ROLES.includes(role));
};

/**
 * Magner копирует route-конфиг спредом при создании роутера, поэтому геттер visible
 * вычислился бы один раз, до загрузки настроек. Сайдбар же читает route.visible при каждом
 * рендере из объектов в props.default.routes layout-записи — меняем флаг прямо в них.
 * Сайдбар перерисуется, когда Magner запишет пользователя в стор после ответа profile.
 */
export const applyAckDocumentsVisibility = (router: RoutesSource) => {
  const visible = isAckDocumentsAvailable();
  let found = false;

  router.getRoutes().forEach((record) => {
    const layoutRoutes = (record.props?.default as { routes?: { name?: string, visible?: boolean }[] } | undefined)
      ?.routes;

    layoutRoutes?.forEach((route) => {
      if (route.name === ACK_DOCUMENTS_ROUTE) {
        route.visible = visible;
        found = true;
      }
    });
  });

  if (!found) {
    console.warn('[AckDocuments.menu] route not found in layout routes', { route: ACK_DOCUMENTS_ROUTE });
    return;
  }

  if (import.meta.env.DEV) {
    const store = useStore();
    console.info('[AckDocuments.menu] visibility', {
      visible,
      enabled: (store.preferences as unknown as ComputedRef<PreferenceItem[]>).value
        ?.find((item) => item.code === ACK_DOCUMENTS_SETTING_CODE)?.value,
      roles: (store.userRoles as unknown as ComputedRef<string[]>).value,
    });
  }
};
